<div class="recibo-container">
  <!-- Header con botones -->
  <div class="recibo-header">
    <div style="display: flex; align-items: center; gap: 1rem;">
      <img src="assets/logo.jpeg" alt="Logo The Detailer" style="height: 50px; border-radius: 8px;">
      <h1>{{ modo === 'token' ? 'Tu Recibo' : 'Órdenes - ' + placa }}</h1>
    </div>
    <div class="botones">
      <button class="btn-descargar" (click)="descargarPDF()" [disabled]="!orden">
        📥 Descargar PDF
      </button>
      <button class="btn-volver" (click)="volver()">
        ← Volver
      </button>
    </div>
  </div>

  <!-- Indicador de carga -->
  <div *ngIf="cargando" class="loading">
    <div class="spinner"></div>
    <p>Cargando{{ modo === 'token' ? ' recibo' : ' órdenes' }}...</p>
  </div>

  <!-- Mensaje de error -->
  <div *ngIf="error && !cargando" class="error-box">
    <p>❌ {{ error }}</p>
    <button class="btn-reintentar" (click)="modo === 'token' ? obtenerRecibo() : obtenerOrdenesPorPlaca()">
      Reintentar
    </button>
  </div>

  <!-- Botón para ver otras órdenes (si hay múltiples) -->
  <div *ngIf="modo === 'placa' && ordenes.length > 1 && !cargando" class="ver-ordenes-btn">
    <button (click)="toggleTodasLasOrdenes()" class="btn-ver-ordenes">
      {{ mostrarTodasLasOrdenes ? '← Ocultar otras órdenes' : `📋 Ver otras ${ordenes.length - 1} orden(es)` }}
    </button>
  </div>

  <!-- Selector de órdenes (expandible) -->
  <div *ngIf="modo === 'placa' && ordenes.length > 1 && mostrarTodasLasOrdenes && !cargando" class="ordenes-selector">
    <h2>Otras órdenes para {{ placa }}:</h2>
    <div class="ordenes-grid">
      <button
        *ngFor="let ord of ordenes"
        class="orden-card"
        [class.activa]="ordenSeleccionada?.id_orden === ord.id_orden"
        (click)="seleccionarOrden(ord.id_orden)">
        <div class="orden-numero">Orden #{{ ord.id_orden }}</div>
        <div class="orden-fecha">{{ obtenerFecha(ord.fecha) }}</div>
        <div class="orden-estado" [ngClass]="'estado-' + formatEstado(ord.estado)">{{ ord.estado }}</div>
        <div class="orden-total">${{ ord.total.toLocaleString('es-CO') }}</div>
      </button>
    </div>
  </div>

  <!-- Recibo ORDEN DE SERVICIO -->
  <div *ngIf="orden && !cargando && tipoRecibo === 'orden'" id="recibo-contenido" class="recibo">
    <!-- Indicador de orden actual (si hay múltiples) -->
    <div *ngIf="modo === 'placa' && ordenes.length > 1" class="orden-actual-badge">
      📋 Orden {{ ordenes.indexOf(orden) + 1 }} de {{ ordenes.length }}
    </div>

    <!-- Header del recibo -->
    <div class="recibo-header-content">
      <div class="empresa">
        <img src="assets/logo.jpeg" alt="Logo" style="height: 40px; margin-bottom: 0.5rem; border-radius: 4px;">
        <h2>{{ obtenerEmojiVehiculo(orden.tipo_vehiculo) }} The Detailer</h2>
        <p>Recibo de Orden de Servicio</p>
        <p style="font-size: 11px; color: #95a5a6; margin-top: 5px;">NIT 100002212-9</p>
      </div>
      <div class="numero-orden">
        <span class="label">Orden #</span>
        <span class="numero">{{ orden.id_orden }}</span>
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Información del cliente y vehículo -->
    <div class="info-grid">
      <div class="info-box">
        <strong>👤 Cliente</strong>
        <p>{{ orden.nombre_cliente }}</p>
      </div>

      <div class="info-box">
        <strong>📅 Fecha de Servicio</strong>
        <p>{{ obtenerFecha(orden.fecha) }} {{ obtenerHora(orden.hora) ? '⏰ ' + obtenerHora(orden.hora) : '' }}</p>
      </div>

      <div class="info-box">
        <strong>🚗 Placa del Vehículo</strong>
        <p class="placa">{{ orden.placa_vehiculo }}</p>
      </div>

      <div class="info-box">
        <strong>🏎️ Vehículo</strong>
        <p>{{ orden.marca_vehiculo }} {{ orden.modelo_vehiculo }}</p>
      </div>

      <div class="info-box">
        <strong>👨‍🔧 Responsable</strong>
        <p>{{ orden.responsable || 'N/A' }}</p>
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Servicios realizados -->
    <div class="servicios-section">
      <h3>✨ Servicios Realizados</h3>

      <table class="servicios-table">
        <thead>
          <tr>
            <th>Servicio</th>
            <th class="cantidad">Cantidad</th>
            <th class="precio">Precio Unitario</th>
            <th class="subtotal">Subtotal</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let servicio of orden.servicios" class="servicio-row">
            <td>{{ servicio.servicio }}</td>
            <td class="cantidad">{{ servicio.cantidad }}</td>
            <td class="precio">${{ servicio.precio_unitario.toLocaleString('es-CO') }}</td>
            <td class="subtotal">${{ servicio.subtotal.toLocaleString('es-CO') }}</td>
          </tr>

          <!-- Fila de total -->
          <tr class="total-row">
            <td colspan="3" class="label-total">TOTAL:</td>
            <td class="monto-total">${{ orden.total.toLocaleString('es-CO') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Información Adicional (Método de Pago + Observaciones) -->
    <div *ngIf="orden.metodoPago || orden.notas || orden.cantidad_cascos" class="info-adicional-section">
      <h3>📋 Información Adicional</h3>
      <div class="rifa-info">
        <div *ngIf="orden.metodoPago" class="rifa-item">
          <strong>💳 Método de Pago:</strong>
          <span>{{ orden.metodoPago }}</span>
        </div>
        <div *ngIf="orden.cantidad_cascos && orden.cantidad_cascos > 0" class="rifa-item">
          <strong>🧢 Cascos a Recoger:</strong>
          <span>{{ orden.cantidad_cascos }}</span>
        </div>
        <div *ngIf="orden.notas" class="rifa-item">
          <strong>📝 Observaciones:</strong>
          <span>{{ orden.notas }}</span>
        </div>
      </div>
    </div>

    <!-- Información de Rifa (SOLO si participa) -->
    <div *ngIf="orden.id_rifa" class="rifa-section">
      <h3>🎰 Participación en Rifa</h3>
      <div class="rifa-info">
        <div class="rifa-item rifa-participacion">
          <strong>🎟️ Número de Boleta:</strong>
          <span class="rifa-numero">#{{ orden.numero_rifa }}</span>
        </div>
        <div class="rifa-item">
          <strong>👤 Jugador:</strong>
          <span>{{ orden.nombre_cliente || 'N/A' }}</span>
        </div>
        <div class="rifa-item">
          <strong>🏆 Premio:</strong>
          <span class="rifa-premio">{{ orden.rifa_premio || 'N/A' }}</span>
        </div>
        <div class="rifa-item">
          <strong>📅 Cuándo Juega:</strong>
          <span>{{ obtenerFecha(orden.fecha_sorteo) || 'Próximamente' }}</span>
        </div>
        <div class="rifa-item">
          <strong>👨‍💼 Encargado de Rifa:</strong>
          <span>{{ orden.encargado_rifa || 'N/A' }}</span>
        </div>
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Estado -->
    <div class="estado-section">
      <p><strong>Estado del Servicio:</strong></p>
      <div [ngClass]="'estado ' + formatEstado(orden.estado)">
        {{ obtenerEstadoFormato(orden.estado) }}
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Footer -->
    <div class="recibo-footer">
      <p>📍 The Detailer</p>
      <p>⏰ Lunes-Domingo 7am-6pm</p>
      <p class="gracias">Gracias por confiar en nosotros 🙏</p>
      <p class="disclaimer">Este recibo fue generado digitalmente.<br>Para cualquier duda, contáctanos.</p>
    </div>
  </div>

  <!-- Recibo VENTA DE MOSTRADOR -->
  <div *ngIf="orden && !cargando && tipoRecibo === 'venta'" id="recibo-contenido" class="recibo recibo-venta">
    <!-- Header del recibo -->
    <div class="recibo-header-content">
      <div class="empresa">
        <img src="assets/logo.jpeg" alt="Logo" style="height: 40px; margin-bottom: 0.5rem; border-radius: 4px;">
        <h2>🛍️ The Detailer</h2>
        <p>Recibo de Compra - Venta de Mostrador</p>
        <p style="font-size: 11px; color: #95a5a6; margin-top: 5px;">NIT 100002212-9</p>
      </div>
      <div class="numero-orden">
        <span class="label">Recibo #</span>
        <span class="numero">{{ orden.id_venta }}</span>
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Información del cliente y venta -->
    <div class="info-grid">
      <div class="info-box">
        <strong>👤 Cliente</strong>
        <p>{{ orden.cliente_nombre }}</p>
      </div>

      <div class="info-box">
        <strong>📅 Fecha de Compra</strong>
        <p>{{ obtenerFecha(orden.fecha) }} {{ obtenerHora(orden.hora) ? '⏰ ' + obtenerHora(orden.hora) : '' }}</p>
      </div>

      <div class="info-box">
        <strong>📍 Sede</strong>
        <p>{{ orden.sede }}</p>
      </div>

      <div class="info-box">
        <strong>💳 Método de Pago</strong>
        <p>{{ orden.metodo_pago || 'N/A' }}</p>
      </div>

      <div class="info-box" *ngIf="orden.vendedor">
        <strong>👨‍💼 Vendedor</strong>
        <p>{{ orden.vendedor }}</p>
      </div>

      <div class="info-box" *ngIf="orden.rifa && orden.rifa.participa">
        <strong>🎟️ Número de Boleta</strong>
        <p class="placa">{{ orden.rifa.numero_rifa }}</p>
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Productos comprados -->
    <div class="servicios-section">
      <h3>🛍️ Productos Comprados</h3>

      <table class="servicios-table">
        <thead>
          <tr>
            <th>Producto</th>
            <th class="cantidad">Cantidad</th>
            <th class="precio">Precio Unitario</th>
            <th class="subtotal">Subtotal</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let producto of orden.productos" class="servicio-row">
            <td>{{ producto.producto }}</td>
            <td class="cantidad">{{ producto.cantidad }}</td>
            <td class="precio">${{ producto.precio_unitario.toLocaleString('es-CO') }}</td>
            <td class="subtotal">${{ producto.subtotal.toLocaleString('es-CO') }}</td>
          </tr>

          <!-- Fila de total -->
          <tr class="total-row">
            <td colspan="3" class="label-total">TOTAL:</td>
            <td class="monto-total">${{ orden.total.toLocaleString('es-CO') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Información de Rifa -->
    <div class="rifa-section">
      <h3>🎰 Participación en Rifa</h3>
      <div class="rifa-info">
        <div *ngIf="orden.rifa && orden.rifa.participa" class="rifa-item rifa-participacion">
          <strong>🎟️ Número de Boleta:</strong>
          <span class="rifa-numero">#{{ orden.rifa.numero_rifa }}</span>
        </div>
        <div *ngIf="!orden.rifa || !orden.rifa.participa" class="rifa-item">
          <strong>🎟️ Participación:</strong>
          <span>No participó</span>
        </div>
        <div *ngIf="orden.rifa && orden.rifa.participa" class="rifa-item">
          <strong>🏆 Premio:</strong>
          <span class="rifa-premio">{{ orden.rifa.premio || 'N/A' }}</span>
        </div>
        <div *ngIf="orden.rifa && orden.rifa.participa" class="rifa-item">
          <strong>📅 Cuándo Juega:</strong>
          <span>{{ orden.rifa.fecha_sorteo || 'Próximamente' }}</span>
        </div>
        <div *ngIf="orden.rifa && orden.rifa.participa" class="rifa-item">
          <strong>👨‍💼 Encargado de Rifa:</strong>
          <span>{{ orden.rifa.encargado || 'N/A' }}</span>
        </div>
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Estado -->
    <div class="estado-section">
      <p><strong>Estado:</strong></p>
      <div class="estado estado-completada">
        ✅ Compra Completada
      </div>
    </div>

    <!-- Separador -->
    <div class="separator"></div>

    <!-- Footer -->
    <div class="recibo-footer">
      <p>📍 The Detailer</p>
      <p>⏰ Lunes-Domingo 7am-6pm</p>
      <p class="gracias">Gracias por confiar en nosotros 🙏</p>
      <p class="disclaimer">Este recibo fue generado digitalmente.<br>Para cualquier duda, contáctanos.</p>
    </div>
  </div>
</div>
